import Error from '../model/Error';
import Sport from '../dto/offering/Sport';
import axios from 'axios';

export default class SportsRepository {
    static findAll(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offerings/sports`)
                .then((response) => resolve(response.data.data.map((data) => Sport.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findAllWithArchived(federationId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/federations/${federationId}/sports?withArchived=true`)
                .then((response) => resolve(response.data.data.map((data) => Sport.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static bulkUpdate(federationId, sports) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/federations/${federationId}/sports`, {
                    sports: sports.map((data) => data.serialize()),
                })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
